/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
import React from "react";
import { ProviderUI } from "./src/contexts/context-ui";

export const wrapRootElement = ({ element }) => (
  <ProviderUI>{element}</ProviderUI>
);
